export default "__VITE_ASSET__BSCsZn6d__"